import { render, staticRenderFns } from "./saveTypeQuery.vue?vue&type=template&id=24f3665c&scoped=true&"
import script from "./saveTypeQuery.vue?vue&type=script&lang=js&"
export * from "./saveTypeQuery.vue?vue&type=script&lang=js&"
import style0 from "./saveTypeQuery.vue?vue&type=style&index=0&id=24f3665c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f3665c",
  null
  
)

export default component.exports